import { OfferType } from '../../common/enums.js';
import { HorizontalMobileBroadbandProductOfferingsCoCo } from '../ProductOfferingsCardCoCo/HorizontalMobileBroadbandProductOfferingsCoCo.js';
import { HorizontalSoftwareProductOfferingsCoCo } from '../ProductOfferingsCardCoCo/HorizontalSoftwareProductOfferingsCoCo.js';
import { HorizontalVoiceProductOfferingsCoCo } from '../ProductOfferingsCardCoCo/HorizontalVoiceProductOfferingsCoCo.js';

export interface ProductOfferingsCardsByOfferTypeCoCoProps {
  offerType: OfferType;
  publicPages: boolean;
}

export const ProductOfferingsCardsByOfferTypeCoCo = ({
  offerType,
  publicPages = false,
}: ProductOfferingsCardsByOfferTypeCoCoProps) => {
  switch (offerType) {
    case OfferType.VOICE:
      return <HorizontalVoiceProductOfferingsCoCo publicPages={publicPages} />;
    case OfferType.MOBILE_BROADBAND:
      return <HorizontalMobileBroadbandProductOfferingsCoCo publicPages={publicPages} />;
    case OfferType.SOFTWARE:
      return (
        <HorizontalSoftwareProductOfferingsCoCo
          // Keep explicit fallback image until contentful asset mapping is introduced.
          image="6ny6a6qP3Mt9gp5rmrUUmc/Elisa-Yritystietoturva-Kotimainen-tietoturvaohjelma-yrityksille.jpg"
          publicPages={publicPages}
        />
      );
    default:
      // For any other model types, use VoiceSubscriptions as default
      return <HorizontalVoiceProductOfferingsCoCo publicPages={publicPages} />;
  }
};
